import {
  DASHBOARD_FILTER_MODAL,
  DASHBOARD_QUERY,
  FACILITY_DASHBOARD_DATA,
  FETCH_FACILITY_TB_DASHBOARD,
  FETCH_FACILITY_TB_TEST_TYPE_DASHBOARD,
  FETCH_GLOBAL_DASHBOARD,
  FETCH_PH_VERIFIED_REPORT,
  FETCH_PRIORITY_TEST_TYPE_DASHBOARD,
  FETCH_PROGRAM_DASHBOARD,
  REPORT_DATA,
  REPORT_LIST,
  REPORT_TEST_TYPE_CONFIG,
  SELECTED_REPORT_TEST_TYPE,
  SET_REPORT_PAGINATION,
} from "constants/ActionTypes";
import { pageSizeOptions } from "utils/Constant";

const INITIAL_STATE = {
  data: [],
  loading: false,
  verifiedPHReportList: [],
  priorityDashboardList: [],
  facilityTBDashboardList: [],
  programDashboardList: [],
  globalDashboardList: {},
  reportDashboardList: [],
  reportData: [],
  reportPagination: {
    count: 0,
    page: 1,
    page_size: pageSizeOptions[1],
    total_pages: 0,
    next: null,
    previous: null,
  },
  facilityDashboardData: [],
  reportTestTypeConfig: {},
  selectedReportTestType: null,
  dashboardFilterModal: false,
  dashboardQuery: {
    scope: null,
    date_range: null,
    program: null,
    test_type: null,
    states: null,
    lga: null,
    facility: null,
    start_date: null,
    end_date: null,
  },
};

const ReportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PH_VERIFIED_REPORT: {
      return {
        ...state,
        verifiedPHReportList: action.payload,
      };
    }
    case FETCH_PROGRAM_DASHBOARD: {
      return {
        ...state,
        programDashboardList: action.payload,
      };
    }
    case FETCH_PRIORITY_TEST_TYPE_DASHBOARD: {
      return {
        ...state,
        priorityDashboardList: action.payload,
      };
    }
    case FETCH_GLOBAL_DASHBOARD: {
      return {
        ...state,
        globalDashboardList: action.payload,
      };
    }
    case FETCH_FACILITY_TB_DASHBOARD: {
      return {
        ...state,
        facilityTBDashboardList: action.payload,
      };
    }
    case FETCH_FACILITY_TB_TEST_TYPE_DASHBOARD: {
      return {
        ...state,
        facilityTBDashboardList: action.payload,
      };
    }
    case REPORT_LIST: {
      return {
        ...state,
        reportDashboardList: action.payload,
      };
    }
    case REPORT_DATA: {
      return {
        ...state,
        reportData: action.payload,
      };
    }

    case SET_REPORT_PAGINATION: {
      return {
        ...state,
        reportPagination: action.payload,
      };
    }

    case FACILITY_DASHBOARD_DATA: {
      return {
        ...state,
        facilityDashboardData: action.payload,
      };
    }

    case REPORT_TEST_TYPE_CONFIG: {
      return {
        ...state,
        reportTestTypeConfig: action.payload,
      };
    }

    case SELECTED_REPORT_TEST_TYPE: {
      return {
        ...state,
        selectedReportTestType: action.payload,
      };
    }

    case DASHBOARD_FILTER_MODAL: {
      return {
        ...state,
        dashboardFilterModal: action.payload,
      };
    }

    case DASHBOARD_QUERY: {
      return {
        ...state,
        dashboardQuery: action.payload,
      };
    }

    default:
      return state;
  }
};

export default ReportReducer;
